import React, { useState, useEffect } from "react"; // Importa React e hooks
import { Link } from 'react-router-dom';
import Imagens from "../../img/imagens";
import './comunicados.css'; // Estilos adicionais para comunicados

//const baseUrl = "https://localhost:44304/api"; // API de DEV (localhost)
const baseUrl = "http://10.80.12.5:81/api"; // API de Produção

// Componente principal para exibir comunicados (clipping)
export default function Comunicados() {
  const [noticias, setNoticias] = useState([]); // Estado para armazenar as notícias

  // Busca os comunicados na API ao montar o componente
  useEffect(() => {
    fetch(`${baseUrl}/Comunicado`)
      .then(response => {
        if (!response.ok) {
          throw new Error("Erro ao buscar os comunicados");
        }
        return response.json();
      })
      .then(data => setNoticias(data))
      .catch(error => console.error("Erro ao buscar dados da API:", error));
  }, []);

  const hoje = new Date().toLocaleDateString(); // Obtém a data atual no formato local

  // Filtra as notícias para mostrar apenas as do dia atual
  const noticiasFiltradas = noticias.filter(noticia => {
    const dataNoticia = new Date(noticia.data).toLocaleDateString();
    return dataNoticia === hoje;
  });

  return (
    <div className="container mt-5">
      <header className="App-header">
        <a
          href="https://www.prefeitura.sp.gov.br/cidade/secretarias/controladoria_geral/"
          target="blank"
          rel="noopener noreferrer"
          className="logolink"
        >
          <img src={Imagens.CGM1} alt="Prefeitura" width="150" className="logo" />
        </a>
        <div className="Voltar">
          <Link className="voltarbtn" to="/">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" className="bi bi-arrow-return-left" viewBox="0 0 16 16">
              <path fillRule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5" />
            </svg>
            <p> &nbsp; Voltar a tela inicial</p>
          </Link>
        </div>
      </header>

      {/* Título da página */}
      <h1 className="text-center mb-4" style={{ color: "#EC6608", marginTop: "100px", fontWeight: "bold", animation: "fadeIn 1s ease-in-out" }}>
        Clipping CGM
      </h1>

      {/* Lista de comunicados filtrados */}
      <ul className="list-group mt-4">
        {noticiasFiltradas.length > 0 ? (
          noticiasFiltradas.map((noticia, index) => (
            <li
              key={index}
              className="list-group-item shadow-sm p-3 mb-3 bg-white rounded"
              style={{ transition: "transform 0.3s" }}
              onMouseEnter={e => e.currentTarget.style.transform = "scale(1.02)"}
              onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
            >
              <span className="fw-bold text-primary">
                <a
                  href={noticia.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none text-primary"
                >
                  {noticia.titulo}
                </a>
              </span>
              <p className="mb-0 text-muted">
                <strong>Fonte:</strong> {noticia.fonte} | <strong>Veículo:</strong> {noticia.veículo} | <strong>Data:</strong> {new Date(noticia.data).toLocaleDateString()}
              </p>
            </li>
          ))
        ) : (
          <p className="text-center text-muted">Nenhum comunicado disponível para a data de hoje.</p>
        )}
      </ul>

      {/* Estilo para animação de fadeIn */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
  );
}